module.exports = "/_next/static/images/img_live_sprite.oA+DeCIQ.png";